var React = require('react');
var { createElement: h } = React;
var AgentSettingsEditor = require('./AgentSettingsEditor');
var AgentConfiguratorModal = require('./AgentConfiguratorModal');
var ClassifierConfiguratorModal = require('./ClassifierConfiguratorModal');
var ClassifierEditor = require('./ClassifierEditor');
var WorkflowPlannerModal = require('./WorkflowPlannerModal');
var PropPicker = require('./PropPickerBalloon');
var AiFlowPromptBalloon = require('./AiFlowPromptBalloon');

function EditorModals(props) {
  var aiPromptState = props.aiPromptState;
  var updateAiPrompt = props.updateAiPrompt;
  var updateAiAgentMode = props.updateAiAgentMode;
  var updateAiModelTier = props.updateAiModelTier;
  var updateAiResponseFields = props.updateAiResponseFields;
  var updateAiNodeKind = props.updateAiNodeKind;
  var generateAiNodeFromPrompt = props.generateAiNodeFromPrompt;
  var finalizeSingleNode = props.finalizeSingleNode;
  var closeAiPrompt = props.closeAiPrompt;
  var subscribeToPan = props.subscribeToPan;
  var pendingAgentDrop = props.pendingAgentDrop;
  var confirmAgentDrop = props.confirmAgentDrop;
  var cancelAgentDrop = props.cancelAgentDrop;
  var pendingClassifierDrop = props.pendingClassifierDrop;
  var confirmClassifierDrop = props.confirmClassifierDrop;
  var cancelClassifierDrop = props.cancelClassifierDrop;
  var editingAgentNode = props.editingAgentNode;
  var agentEditorPosition = props.agentEditorPosition;
  var closeAgentEditor = props.closeAgentEditor;
  var saveAgentParams = props.saveAgentParams;
  var getEditorContextNodes = props.getEditorContextNodes;
  var editingClassifierNode = props.editingClassifierNode;
  var classifierEditorPosition = props.classifierEditorPosition;
  var closeClassifierEditor = props.closeClassifierEditor;
  var saveClassifierParams = props.saveClassifierParams;
  var propPickerState = props.propPickerState;
  var propPickerPosition = props.propPickerPosition;
  var handlePropPickerSelect = props.handlePropPickerSelect;
  var closePropPicker = props.closePropPicker;
  var plannerOpen = props.plannerOpen;
  var setPlannerOpen = props.setPlannerOpen;
  var autoBuildWorkflow = props.autoBuildWorkflow;
  var handleManualFix = props.handleManualFix;
  var variableNodes = props.variableNodes;

  return h(React.Fragment, null,
    aiPromptState
      ? h(AiFlowPromptBalloon, {
          sourceTitle: aiPromptState.futureConnector && aiPromptState.futureConnector.nodeTitle
            ? aiPromptState.futureConnector.nodeTitle
            : 'Node',
          targetTitle: aiPromptState.insertTargetTitle || '',
          isInsertBetween: !!aiPromptState.insertConnectionId,
          toolMode: !!aiPromptState.toolMode,
          position: aiPromptState.position,
          prompt: aiPromptState.prompt,
          loading: aiPromptState.loading,
          error: aiPromptState.error,
          agentMode: aiPromptState.agentMode,
          modelTier: aiPromptState.modelTier,
          responseFields: aiPromptState.responseFields,
          nodeKind: aiPromptState.nodeKind || 'custom',
          singleNodeContext: aiPromptState.singleNodeContext || null,
          onPromptChange: updateAiPrompt,
          onAgentModeChange: updateAiAgentMode,
          onModelTierChange: updateAiModelTier,
          onResponseFieldsChange: updateAiResponseFields,
          onNodeKindChange: updateAiNodeKind,
          onGenerate: generateAiNodeFromPrompt,
          onNodeReady: finalizeSingleNode,
          onClose: closeAiPrompt,
          subscribeToPan: subscribeToPan
        })
      : null,
    pendingAgentDrop
      ? h(AgentConfiguratorModal, {
          onConfirm: confirmAgentDrop,
          onCancel: cancelAgentDrop,
          variableNodes: variableNodes
        })
      : null,
    pendingClassifierDrop
      ? h(ClassifierConfiguratorModal, {
          onConfirm: confirmClassifierDrop,
          onCancel: cancelClassifierDrop,
          variableNodes: variableNodes
        })
      : null,
    editingAgentNode
      ? h(AgentSettingsEditor, {
          title: editingAgentNode.title || 'Agent',
          initialParams: editingAgentNode.paramValues || {},
          position: agentEditorPosition,
          onClose: closeAgentEditor,
          onSave: saveAgentParams.bind(null, editingAgentNode.id),
          variableNodes: getEditorContextNodes(editingAgentNode.id)
        })
      : null,
    editingClassifierNode
      ? h(ClassifierEditor, {
          title: editingClassifierNode.title || (editingClassifierNode.icon === 'router' ? 'Router' : 'Classifier'),
          initialParams: editingClassifierNode.paramValues || {},
          position: classifierEditorPosition,
          onClose: closeClassifierEditor,
          onSave: saveClassifierParams.bind(null, editingClassifierNode.id),
          hideInstruction: editingClassifierNode.icon === 'router',
          labelsTitle: editingClassifierNode.icon === 'router' ? 'Routes' : 'Classification Labels',
          settingsTitle: editingClassifierNode.icon === 'router' ? 'Router Settings' : 'Classifier Settings'
        })
      : null,
    propPickerState && propPickerPosition
      ? h(PropPicker, {
          output: propPickerState.output,
          position: propPickerPosition,
          onSelect: handlePropPickerSelect,
          onClose: closePropPicker
        })
      : null,
    plannerOpen
      ? h(WorkflowPlannerModal, {
          onClose: function() { setPlannerOpen(false); },
          onBuildWorkflow: function(plan, callbacks) {
            autoBuildWorkflow(plan, callbacks);
          },
          onFixNode: handleManualFix,
          plannerContext: {
            existingVariables: variableNodes.map(function(node) {
              var pv = node && node.paramValues ? node.paramValues : {};
              return {
                name: String((node && node.title) || '').trim(),
                dataType: String(pv.dataType || 'string').toLowerCase(),
                mode: String(pv.retain) === 'true' ? 'static' : 'run'
              };
            }).filter(function(v) { return !!v.name; })
          }
        })
      : null
  );
}

module.exports = EditorModals;
